import { Link } from 'react-router';
import { useConsent } from '@/client/consent/ConsentContext';
import { useI18n } from '@/client/i18n/I18nContext';
import { lp } from '@/client/i18n/locale';

export function CookieConsent() {
  const { bannerOpen, accept } = useConsent();
  const { t } = useI18n();

  if (!bannerOpen) return null;

  return (
    <div
      className="consent"
      role="dialog"
      aria-live="polite"
      aria-label={t('consent.title')}
    >
      <div className="container consent__inner">
        <p className="consent__text">
          {t('consent.body')}{' '}
          <Link to={lp('/legal/cookies')} className="link-underline">
            {t('consent.more')}
          </Link>
        </p>
        <div className="consent__actions">
          <button type="button" className="btn btn--ghost" onClick={() => accept(false)}>
            {t('consent.reject')}
          </button>
          <button type="button" className="btn" onClick={() => accept(true)}>
            {t('consent.accept')}
          </button>
        </div>
      </div>
    </div>
  );
}
